import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, withKeys as _withKeys, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3b0f26da")

_pushScopeId("data-v-3b0f26da")
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "thumbnail" }
const _hoisted_3 = { class: "commands" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "これで制作", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "sentence" }, "このマンガ家の作品を", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "br-right sentence" }, "全部見る", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Thumbnail = _resolveComponent("Thumbnail")
  const _component_modal = _resolveComponent("modal")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Thumbnail, { item: _ctx.thumbnailItem }, null, 8, ["item"]),
    _createVNode(_component_modal, {
      isShow: _ctx.isShowModal,
      "onUpdate:isShow": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowModal = $event)),
      isFitSize: true,
      onKeydown: _withKeys(_withModifiers(_ctx.toEdit, ["prevent"]), ["enter"])
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.twoBytwoOrder(_ctx.item.frames), (frame, i) => {
              return (_openBlock(), _createBlock("img", {
                key: frame.id,
                src: _ctx.toResourceUrl(frame.balloonOn),
                class: {
              lt: i == 0,
              rt: i == 1,
              lb: i == 2,
              rb: i == 3,
            }
              }, null, 10, ["src"]))
            }), 128))
          ]),
          _withDirectives(_createVNode("div", { class: "describe" }, _toDisplayString(_ctx.item.describe), 513), [
            [_vShow, _ctx.isExistDescribe]
          ]),
          _createVNode("div", _hoisted_3, [
            _createVNode("button", {
              class: "app-button select-button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toEdit && _ctx.toEdit(...args)))
            }, [
              _hoisted_4
            ]),
            (!_ctx.isHideMoreLink)
              ? (_openBlock(), _createBlock("a", {
                  key: 0,
                  class: "more-author",
                  href: "#",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.more && _ctx.more(...args)), ["prevent"]))
                }, [
                  _hoisted_5,
                  _hoisted_6
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["isShow", "onKeydown"])
  ]))
})